import React, { Component, ErrorInfo, ReactNode } from 'react';
import { BodyErrorAgent } from './components';
import { ThemeProvider } from 'styled-components';
import light from '../../../styles/GlobalStyle/themes/light';
import common from '../../../styles/GlobalStyle/themes/common';

interface IErrorBoundaryProps {
  children: ReactNode;
}

interface IErrorBoundaryState {
  hasError: boolean;
  error: string;
}

class ErrorBoundary extends Component<IErrorBoundaryProps, IErrorBoundaryState> {
  constructor(props: IErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: '' };
  }

  static getDerivedStateFromError(error: Error): IErrorBoundaryState {
    sendlog(error);
    return { hasError: true, error: error.message };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <ThemeProvider theme={{ ...common, fontSizeType: 'normal', ...light }}>
          <BodyErrorAgent />
        </ThemeProvider>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

function sendlog(error: Error) {
  /** Função para começarmos a trackear o log dos erros*/
  void error;
}
